// extracted by mini-css-extract-plugin
export var loadingSpinner = "_t-0";
export var spinnerContainer = "_t-1";